import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import * as React from "react";
import { FC } from "react";
import { css } from "styled-components";

const enum fields {
    color = "color",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.color]: string;
    };
}

export interface HorizontalDividerStyles {
    horizontalDividerStyles?: InjectableCss;
}

export const horizontalDividerStyles: HorizontalDividerStyles = {
    horizontalDividerStyles: {
        css: css`
            width: 100%;
        `,
    },
};

export const HorizontalDividerWidget: FC<{
    fields: {
        [fields.color]: string;
    };
    sizeMobile: number;
    sizeDesktop: number;
}> = ({ fields, sizeMobile, sizeDesktop }) => {
    const styles = {
        css: css`
            ${horizontalDividerStyles.horizontalDividerStyles?.css || ""}
            background-color: ${fields.color};
            height: ${sizeMobile}px;
            ${mediaQueriesBP.maxMD} {
                height: ${sizeDesktop}px;
            }

            @media print {
                background: none;
                height: 0;
                border-bottom: solid ${sizeDesktop}px ${fields.color};
            }
        `,
    };

    return <StyledWrapper {...styles} />;
};

export const HorizontalDivider: FC<OwnProps> = ({ fields }) => {
    const { isInShell } = useShellContext();

    return <HorizontalDividerWidget fields={fields} sizeMobile={4} sizeDesktop={6}></HorizontalDividerWidget>;
};

const widgetModule: WidgetModule = {
    component: HorizontalDivider,
    definition: {
        group: "Basic",
        icon: "arrows-v",
        fieldDefinitions: [
            {
                name: fields.color,
                editorTemplate: "ColorPickerField",
                fieldType: "General",
                displayName: "Color",
                sortOrder: 1,
                defaultValue: "#b89e7d",
            },
        ],
    },
};

export default widgetModule;
